import type { Todo } from "./types";

const now = Date.now();

function dateFromNow(days: number) {
  const date = new Date(now);
  date.setDate(date.getDate() + days);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export const demoTodos: Todo[] = [
  {
    id: "demo-1",
    organization_id: "goodness-demo",
    title: "週次レポートの自動要約",
    description: "会議前の読み込み時間を減らすため、要点と意思決定を自動抽出する。",
    status: "in_progress",
    due_date: dateFromNow(2),
    hypothesis: "レポートを3行に要約すると、定例会議の準備時間が半分になる",
    expected_result: "準備時間が平均20分から10分以内になる",
    success_criteria: "5人中4人が要約だけで議論を開始できる",
    relations: [],
    created_at_ms: now - 1000 * 60 * 60 * 24 * 8,
    updated_at_ms: now - 1000 * 60 * 18,
  },
  {
    id: "demo-2",
    organization_id: "goodness-demo",
    parent_todo_id: "demo-1",
    title: "オンボーディングを3ステップに短縮",
    description: "初回体験で価値に到達するまでの摩擦を減らす。",
    status: "in_review",
    due_date: dateFromNow(7),
    hypothesis: "初期設定を3項目に絞ると、初日の完了率が20%上がる",
    expected_result: "オンボーディング完了率が72%以上",
    success_criteria: "新規ユーザー30人で検証",
    relations: [],
    created_at_ms: now - 1000 * 60 * 60 * 24 * 4,
    updated_at_ms: now - 1000 * 60 * 60 * 3,
  },
  {
    id: "demo-3",
    organization_id: "goodness-demo",
    parent_todo_id: "demo-2",
    title: "小さな成功を通知する",
    description: "継続利用につながるポジティブなフィードバックを増やす。",
    status: "todo",
    due_date: dateFromNow(-1),
    hypothesis: "成果を即時に伝えると、翌週の再訪率が上がる",
    expected_result: "7日後の再訪率が8ポイント向上",
    success_criteria: "A/Bテストで有意差を確認",
    relations: [],
    created_at_ms: now - 1000 * 60 * 60 * 24 * 2,
    updated_at_ms: now - 1000 * 60 * 60 * 9,
  },
  {
    id: "demo-4",
    organization_id: "goodness-demo",
    title: "インタビュー依頼の文面改善",
    description: "依頼の背景と所要時間を先に伝える。",
    status: "completed",
    due_date: dateFromNow(-5),
    hypothesis: "所要時間を明記すると返信率が上がる",
    expected_result: "返信率を35%から50%へ改善",
    success_criteria: "20件以上送信する",
    actual_result: "24件中14件から返信があり、返信率は58%だった",
    learning: "依頼理由よりも、所要時間と候補日の提示が返信のしやすさに効いた",
    relations: [],
    created_at_ms: now - 1000 * 60 * 60 * 24 * 16,
    updated_at_ms: now - 1000 * 60 * 60 * 24,
    completed_at_ms: now - 1000 * 60 * 60 * 24,
  },
  {
    id: "demo-5",
    organization_id: "goodness-demo",
    parent_todo_id: "demo-4",
    title: "検索結果のカード化",
    description: "情報量を増やして比較しやすくする。",
    status: "completed",
    hypothesis: "カード表示にすると候補の比較が速くなる",
    expected_result: "選択までの時間を15%短縮",
    actual_result: "情報量が多すぎて、かえって判断が遅くなった",
    learning: "比較軸を先に定義しないまま情報量だけ増やしてはいけない",
    relations: [],
    created_at_ms: now - 1000 * 60 * 60 * 24 * 30,
    updated_at_ms: now - 1000 * 60 * 60 * 24 * 5,
  },
];
